import { Stack, Button, alpha, useTheme } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"

/**
 * Approve / reject for a PENDING booking. One component so the pending card and the booking
 * details card offer the decision in exactly the same form.
 */
const BookingDecisionButtons = ({ onApprove, onReject, disabled = false }) => {
  const theme = useTheme()

  return (
    <Stack direction="row" spacing={1.5}>
      <Button
        variant="contained"
        color="success"
        startIcon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
        onClick={onApprove}
        disabled={disabled}
        fullWidth
        disableElevation
        sx={{
          fontWeight: 600,
          textTransform: "none",
          fontSize: "13px",
          py: 1,
          borderRadius: "8px",
          bgcolor: "#2e7d32",
          "&:hover": {
            bgcolor: "#1b5e20",
          },
        }}
      >
        Jóváhagyás
      </Button>
      <Button
        variant="outlined"
        color="error"
        startIcon={<CancelIcon sx={{ fontSize: 16 }} />}
        onClick={onReject}
        disabled={disabled}
        fullWidth
        sx={{
          fontWeight: 600,
          textTransform: "none",
          fontSize: "13px",
          py: 1,
          borderRadius: "8px",
          borderWidth: "1.5px",
          "&:hover": {
            borderWidth: "1.5px",
            bgcolor: alpha(theme.palette.error.main, 0.04),
          },
        }}
      >
        Elutasítás
      </Button>
    </Stack>
  )
}

export default BookingDecisionButtons
